import { useNavigate } from 'react-router-dom';
import Button from '../../ui/Button';
import { ReactNode } from 'react';
interface IFormButtonsProps {
  isLoading: boolean;
  children: ReactNode;
  buttonStyle?: string;
  toggleModal?: () => void;
}
const FormButtons = ({
  isLoading,
  children,
  buttonStyle,
  toggleModal,
}: IFormButtonsProps) => {
  const navigate = useNavigate();
  return (
    <div
      className={`d-flex align-items-center justify-content-end gap-3 flex-wrap flex-sm-nowrap ${buttonStyle}`}
    >
      <Button
        className={'btn btn-danger px-5'}
        type="button"
        onClick={toggleModal ? () => toggleModal() : () => navigate(-1)}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        className="btn btn-primary px-5"
        isLoading={isLoading}
      >
        {children}
      </Button>
    </div>
  );
};
export default FormButtons;
